import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { ConsumerQuote } from '@shared/consumerPlan';
import { consumerApi, consumerQuoteKeys } from '../api/consumer-api';

export function useConsumerQuotes(clientId: string) {
  const query = useQuery({
    queryKey: consumerQuoteKeys.detail(clientId),
    queryFn: () => consumerApi.getQuotes(clientId),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });

  const quotes = useMemo(() => (query.data?.quotes ?? []) as ConsumerQuote[], [query.data]);

  return {
    quotes,
    carrierCount: query.data?.carrierCount ?? 0,
    usaState: query.data?.usaState ?? null,
    noQuotesReason: query.data?.noQuotesReason,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
